module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_arrow4-b02595c4c44d13b32f5eb4ce0433cea0.svg";